import { onDocumentReady } from "@story/story_assets";

function activateSortableTable(table) {
	let draggedRow = null;
	let dragoverQueued = false;
	let dragoverEvent = null;

	table.addEventListener('dragstart', e => {
		draggedRow = e.target;
		// e.target.style.opacity = '0.5';
		// e.target.style.background = 'red'
		e.target.classList.add('dragging');
	});

	table.addEventListener('dragend', e => {
		e.target.classList.remove('dragging');
		draggedRow = null;
	});

	table.addEventListener('dragover', e => {
		e.preventDefault();
		const target = e.target.closest('tr');
		if (target && target != draggedRow) {
			// table.insertBefore(draggedRow, target.nextSibling);
			console.log('dragover');

			const rect = target.getBoundingClientRect();
			const next = (e.clientY - rect.top) > (rect.height / 2);
			table.insertBefore(draggedRow, next ? target.nextSibling : target);
		}
	});
}

onDocumentReady(() => {
	for (const table of document.querySelectorAll("tbody.sortable")) {
		activateSortableTable(table);
	}
});